<template>
  <v-card color="secondary" class="mt-1" flat>
    <v-card-title>
      <span class="subtitle-1">
        Google knowledge graph
      </span>
      <v-spacer></v-spacer>
      <v-btn icon  @click="flipContent">
        <v-icon :color=showIconColor>{{showIcon}}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="showContent">
      <v-simple-table v-if="item">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="subtitle-2">{{ item.name }}</td>
              <td v-if="bigEnough"  class="text-right">{{ item.id }}</td>
            </tr>
            <tr v-if="!bigEnough">
              <td>{{ item.id }}</td>
            </tr>
            <tr>
              <td><v-img v-if="item.imageContentUrl" :src="item.imageContentUrl"></v-img></td>
              <td v-if="bigEnough">{{item.articleBody}}</td>
            </tr>
            <tr v-if="!bigEnough">
              <td >{{item.articleBody}}</td>
            </tr>
            <tr v-if="item.url">
              <td :colspan="colspan">
                <a :href="item.url" target="_blank">
                  Website
                </a>
              </td>
            </tr>
            <tr v-if="item.wiki">
              <td :colspan="colspan">
                <a :href="item.wiki" target="_blank">
                  Wikipedia
                </a>
              </td>
            </tr>
            <tr v-if="item.imageUrl">
              <td :colspan="colspan">
                <a :href="item.imageUrl" target="_blank">
                  Image usage info
                </a>
              </td>
            </tr>
            <tr v-if="item.license">
              <td :colspan="colspan">
                <a :href="item.license" target="_blank">
                  License info
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <span v-else>
        No knowledge graph data found
      </span>
    </v-card-text>
</v-card>
</template>
<script>
import { getIconColor, getIcon } from '@/js/store'
export default {
  props: {
    item:Object,
    flipper: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    flipContent () {
      this.showContent = !this.showContent
      this.$emit('kgshow', this.showContent)
    },
    getIcon (name) {
      return getIcon(name)
    },
    getIconColor (name) {
      return getIconColor(name)
    }
  },
  computed: {
    colspan () {
      return this.bigEnough ? 2 : 1
    },
    showIcon () {
      return getIcon(this.showContent ? 'hide' : 'show')
    },
    showIconColor () {
      return getIconColor(this.showContent ? 'hide' : 'show')
    },
    bigEnough () {
      return this.$vuetify.breakpoint.smAndUp
    },
  },
  data: function () {
    return {
      showContent: this.flipper
    }
  }
}
</script>